const EPSILON = 0.05; // Точность вычислений

export type TextSpaces = {
  letterSpacing: number;
  wordSpacing: number;
};

/** Вычисляет letterSpacing и wordSpacing, растягивающие текст по ширине контейнера */
export function calculateTextSpaces(containerEl: HTMLDivElement, textEl: HTMLSpanElement): TextSpaces {
  const { width: containerWidth } = containerEl.getBoundingClientRect();

  let middle = 0; // текущее значение letterSpacing и wordSpacing
  let left = -20; // минимальное значение
  let right = 100; // максимальное значение

  // Ограничение количества итераций на случай, если ширина перестанет изменяться корректно
  let count = 0;

  while (left <= right && count < 70) {
    middle = (left + right) / 2;

    textEl.style.letterSpacing = `${middle}px`;
    textEl.style.wordSpacing = `${middle}px`;

    // scrollWidth не учитывает letterSpacing, поэтому вычитаем его, чтобы получить реальную ширину текста
    if (textEl.scrollWidth - middle > containerWidth) {
      right = middle - EPSILON;
    } else {
      left = middle + EPSILON;
    }

    count++;
  }

  // Доводка при погрешности: уменьшаем spacing, пока текст не уместится в контейнер
  while (textEl.scrollWidth - middle > containerWidth && count < 70) {
    middle -= EPSILON;

    textEl.style.letterSpacing = `${middle}px`;
    textEl.style.wordSpacing = `${middle}px`;
  }

  return { letterSpacing: middle, wordSpacing: middle };
}
